import { render, staticRenderFns } from "./ContractShutter.vue?vue&type=template&id=c45b155a&"
import script from "./ContractShutter.vue?vue&type=script&lang=js&"
export * from "./ContractShutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports